import EventEmitter from 'events';
import { authService } from '../../../_services';
import { msal_config } from '../../../constants/service';
import { PublicClientApplication } from '@azure/msal-browser'
import { requestService } from './../../../_services';;

const userlogin = 'islogged';
const loginExpiryKey = 'tokenExpiry';
const Userinfo = 'userinfo';

class Auth extends EventEmitter {
    authToken = null
    userProfile = null
    // Login
    localLogin(authResult) {
        //  // get payload
        // if (authResult.access_token === undefined){
        //     return;
        // }
        // var payload = authResult.access_token.split('.');
        // if (payload.length !== 3){
        //     return;
        // }
        // var user_data = null;
        // try {
        //     user_data = JSON.parse(window.atob(payload[1]));
        // } catch {
        //     return;
        // }


        localStorage.setItem(loginExpiryKey, authResult.exp);
        localStorage.setItem(userlogin, 'true');
        localStorage.setItem(Userinfo, JSON.stringify(authResult));
    }

    Logout() {
        localStorage.removeItem(loginExpiryKey);
        localStorage.removeItem(userlogin);
        localStorage.removeItem(Userinfo);
        // this.$router.push('/login').catch();
    }

    isAuthenticated() {
        var isAuthenticated = false;
        if (localStorage.getItem(userlogin) === 'true') {
            if (localStorage.getItem(loginExpiryKey) - Math.floor(new Date().getTime() / 1000)>0){
                isAuthenticated = true;
            }else{
                var userInfo =localStorage.getItem(Userinfo)
                if(userInfo ==null){
                    isAuthenticated=false
                    return isAuthenticated;
                }
                userInfo=JSON.parse(userInfo)
                /*userInfo.access_token_ms=accessTokenResponse.accessToken
                userInfo.exp_ms=timestampInSeconds
                localStorage.setItem(loginExpiryKey, timestampInSeconds);
                localStorage.setItem(Userinfo, JSON.stringify(userInfo));*/

                let exp = localStorage.getItem(loginExpiryKey)

                var isRefreshed = requestService.refreshToken();
                if (isRefreshed) {
                    console.log("aa");
                    isAuthenticated=true;
                    return isAuthenticated;
                } else {
                    console.log("bb");
                    isAuthenticated=false;
                    return isAuthenticated;
                }

                /*this.$msalInstance = new PublicClientApplication(msal_config);
                const accounts = this.$msalInstance.getAllAccounts();
                if (accounts.length >0) {
                    var silentRequest = {
                        scopes: ["User.Read"],
                        account: accounts[0],
                        //forceRefresh: false
                    };
                    this.$msalInstance.acquireTokenSilent(silentRequest).then(function (accessTokenResponse){
                        const timestampInSeconds = Math.floor(accessTokenResponse.expiresOn.getTime() / 1000);
                        var userInfo =localStorage.getItem(Userinfo)
                        if(userInfo ==null){
                            isAuthenticated=false
                            return
                        }
                        userInfo=JSON.parse(userInfo)
                        userInfo.access_token_ms=accessTokenResponse.accessToken
                        userInfo.exp_ms=timestampInSeconds
                        localStorage.setItem(loginExpiryKey, timestampInSeconds);
                        localStorage.setItem(Userinfo, JSON.stringify(userInfo));
                        isAuthenticated = true;
                    }).catch(async (error) => {
                        console.log("InteractionRequiredAuthError ",error)
                        isAuthenticated = false;
                    });          
                } */   
            }
        }
        return isAuthenticated;
    }

    // login
    login (email,passwordjwt) {
        authService.login(email,passwordjwt);
    }
}

export default new Auth();